<div class="eco-portal">
  <router-outlet></router-outlet>
</div>
